export default "__VITE_ASSET__BbgHvrvu__"